import { ArrowLeft, ArrowLeftRight, BarChart3, ClipboardList, FileText, GraduationCap, LayoutDashboard, Megaphone, Package, Receipt, Settings, ShieldCheck, Store, UsersRound } from "lucide-react";

const ALL_SECTIONS = [
  { id: "panou", label: "Panou control", hint: "Vizitatori, comenzi și valori pe branduri", icon: LayoutDashboard, big: true },
  { id: "campanii", label: "Campanii", hint: "Oferte și reduceri pe fiecare brand", icon: Megaphone, big: true },
  { id: "proforme", label: "Proforme", hint: "Proforme pe agenți, comenzi din chat, WhatsApp, Excel facturare", icon: Receipt, big: true },
  { id: "agenti", label: "Agenți", hint: "Invitații, mesaje WhatsApp, istoric mutări", icon: UsersRound, big: true },
  { id: "mutari", label: "Mută saloane", hint: "Muți unul sau mai multe saloane de la un agent la altul", icon: ArrowLeftRight, big: true },
  { id: "liste", label: "Liste de prețuri", hint: "Trimiți listele pe WhatsApp direct la salon, cu istoric", icon: FileText, big: true },
  { id: "fise", label: "Planificare · Fișe clienți", hint: "Fișa fiecărui salon: vizite, firmă, servicii, branduri, poze, comenzi", icon: ClipboardList, big: true },
  { id: "educatie", label: "Educație internațională", hint: "Evenimente pe brand, clienți interesați și înscriși, Excel", icon: GraduationCap, big: true },
  { id: "saloane", label: "Saloane", hint: "Înscrieri, saloane fără agent, WhatsApp", icon: Store, big: true },
  { id: "contracte", label: "Contracte", hint: "Semnate, resemnate, nesemnate, GDPR și seriile agenților", icon: ShieldCheck, big: true },
  { id: "produse", label: "Produse", hint: "Prețuri, coduri, stoc, pachete, cataloage", icon: Package, big: true },
  { id: "rapoarte", label: "Rapoarte", hint: "Agenți, saloane, oferte", icon: BarChart3, big: true },
  { id: "setari", label: "Setări", hint: "Publicare, date de lansare și final", icon: Settings },
].map((s) => ({ ...s, img: `/admin-tiles/${["contracte", "fise"].includes(s.id) ? `${s.id}-3d` : s.id}.jpg` }));
export const SECTIONS = ALL_SECTIONS;
export const SUBS = {
  produse: [["preturi", "Prețuri"], ["cataloage", "Cataloage"]],
  rapoarte: [["agenti", "Rapoarte agenți"], ["saloane", "Rapoarte saloane"], ["oferte", "Rapoarte oferte"]],
};

export const BFTiles = ({ badges, onOpen, sections = SECTIONS }) => (
  <div className="bfa-tiles" data-testid="bfa-tiles">
    {sections.map(({ id, label, hint, icon: Icon, img }, i) => (
      <button key={id} type="button" className={`bfa-tile ${img ? "has-img" : ""}`} style={{ animationDelay: `${i * 45}ms` }} onClick={() => onOpen(id)} data-testid={`bfa-tile-${id}`}>
        {img ? <img className="bfa-tile-img" src={img} alt="" loading="lazy" /> : <span className="bfa-tile-icon"><Icon size={26} strokeWidth={1.6} /></span>}
        <b>{label}</b>
        <small>{hint}</small>
        {badges[id] > 0 && <em className="bfa-tile-badge" data-testid={`bfa-tile-badge-${id}`}>{badges[id]}</em>}
      </button>
    ))}
  </div>
);

export const BFSectionHead = ({ id, sub, onBack, onOpen, sections = SECTIONS, subs = SUBS }) => {
  const s = sections.find((x) => x.id === id);
  const Icon = s.icon;
  return (
    <div className="bfa-sec-head" data-testid="bfa-section-head">
      <button type="button" className="st-btn st-btn--ghost bfa-back-menu" onClick={onBack} data-testid="bfa-back-menu"><ArrowLeft size={16} /> Meniu</button>
      <h2><Icon size={22} strokeWidth={1.6} /> {s.label}</h2>
      <nav className="bfa-sec-nav">
        {sections.map((x) => <button key={x.id} type="button" onClick={() => onOpen(x.id)} className={x.id === id ? "is-on" : ""} data-testid={`bfa-sec-nav-${x.id}`}>{x.label}</button>)}
      </nav>
      {subs[id] && (
        <nav className="bfa-sub-nav" data-testid="bfa-sub-nav">
          {subs[id].map(([t, label]) => <button key={t} type="button" onClick={() => onOpen(id, t)} className={t === sub ? "is-on" : ""} data-testid={`bfa-sub-${id}-${t}`}>{label}</button>)}
        </nav>
      )}
    </div>
  );
};
